module.exports = __webpack_public_path__ + "img/bot_not_understand_bg.009053b3.jpg";